const reports = {
	title: "Rapporter",
	select_report: "Velg rapport",
	filter_period: "Velg rapporter",
	from_date: "Fra dato",
	to_date: "Til dato",
	export_to_excel: "Eksporter til Excel",
	rpt_course_overview: "Kursoversikt",
	rpt_student_course_overview: "Elev oversikt",
	rpt_billing: "Faktura rapport",
	rpt_detailed_enrolment: "Oversikt over påmeldinger",
	run_report: "Kjør",
	filter: "Filter",
	instructor: "Instruktør",
	first_name: "Fornavn",
	last_name: "Etternavn",
	course_name: "Kursnavn",
	course_type: "Kompetanseområde",
	course_template: "Kursmal",
	enrolled_on: "Meldt på",
	address: "Adresse",
	week: "Uke",
	start_date: "Start dato",
	end_date: "Slutt dato",
	qty_of_seats: "Plasser",
	qty_enrolled: "Påmeldte",
	qty_attended: "Deltatt",
	accomplishment: "Gjennomførings %",
	meet_up: "Oppmøte %",
	company: "Selskap",
	zip: "Postnr",
	city: "Sted",
	price: "Pris",
	addons: "Tillegg",
	total_price: "Total pris",
	attended: "Deltatt",
	filter_select_either_1: "Selskap og/eller elev eller kurstype må vøære valgt.,",
};
export default reports;